import { useQuery } from '@tanstack/react-query';
import { tourParticipantCustomFieldsApiQueryKeys } from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.queryKeys.ts';
import tourParticipantCustomFieldsApi from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.ts';

const useGetTourCustomFields = (tourId: string) => {
  return useQuery({
    queryKey: tourParticipantCustomFieldsApiQueryKeys.allForTour(tourId),
    queryFn: () => tourParticipantCustomFieldsApi.getAllFieldsForTour(tourId),
    enabled: !!tourId,
  });
};

export default useGetTourCustomFields;
